import React, { useState, useEffect } from 'react';
import './CreateOffer.css';
import { assets } from '../../../assets/assets';
import Navbar from '../Navbar/Navbar';
import { Bars } from 'react-loader-spinner';
import Dropdown from '../../MyComponents/Dropdown/Dropdown';
import { postData } from '../../../services/apiServices';
import toastService from '../../../services/toastService';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Loader from '../../MyComponents/Loader/Loader';

const PROPERTY_TYPE = [
    { value: 'appartment', label: 'Appartment' },
    { value: 'villa', label: 'Villa' },
    { value: 'land', label: 'Land' },
    { value: 'extension', label: 'Extension' },

];

const PROPERTY_STATUS = [
    { value: 'Ready', label: 'Ready' },
    { value: 'Under Construction', label: 'Under Construction' },

];

const PAYMENT_METHOD = [
    { value: 'Cash', label: 'Cash' },
    { value: 'Bank Transfer', label: 'Bank Transfer' },

];



function CreateOffer() {
    const userInfo = useSelector((state) => state.user.userInfo);

    const [offerTitle, setOfferTitle] = useState('');
    const [noOfRooms, setNoOfRooms] = useState('');
    const [location, setLocation] = useState('');
    const [district, setDistrict] = useState('');
    const [price, setPrice] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [neighbour, setNeighbour] = useState('');
    const [developerName, setDeveloperName] = useState('');
    const [propertyStatus, setPropertyStatus] = useState('');
    const [paymentMehod, setPaymentMethod] = useState('');

    const [area, setArea] = useState('');
    const [images, setImages] = useState([]);
    const [propertyType, setPropertyType] = useState('');
    const [offerDetail, setOfferDetail] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [startDate, setStartDate] = useState(new Date());
    const [isFeatured, setIsFeatured] = useState(null);

    const myData = useLocation();
    const offerType = myData?.state?.offerType || "Offer";


    const handleImageUpload = async (event) => {
        const files = event.target.files;
        if (!files.length) {
            toastService.showError('No images selected');
            return;
        }

        const uploadedImages = [];
        setIsLoading(true);

        try {
            for (const file of files) {
                const formData = new FormData();
                formData.append('verification_token', '123456');
                formData.append('files_upload', file);

                const response = await fetch('https://appvelo.com/realestateOfferAPI/fileupload', {
                    method: 'POST',
                    body: formData,
                });

                const result = await response.json();
                if (result.message === 'success') {
                    uploadedImages.push(result.url);
                    // toastService.showSuccess(`Image uploaded successfully`);
                } else {
                    toastService.showError(result.message || 'Image upload failed');
                }
            }

            setImages([...images, ...uploadedImages]);
        } catch (error) {
            console.error('Error uploading images:', error);
            toastService.showError('Image upload failed');
        } finally {
            setIsLoading(false);
        }
    };



    const validateForm = () => {
        if (!offerTitle || !noOfRooms || !location || !district || !price || !developerName || !propertyType || !propertyStatus || !area || !offerDetail) {
            toastService.showError("Please fill out all required fields.");
            return false;
        }

        if (offerType === "Offer" && (!phoneNumber || !neighbour || !developerName)) {
            toastService.showError("Please fill out all required fields.");
            return false;
        }

        return true;
    };


    const handleRemoveImage = (index) => {
        const updatedImages = images.filter((_, imgIndex) => imgIndex !== index);
        setImages(updatedImages);
    };
    const handleSubmitOffer = async (event) => {
        const currentDate = new Date();
        const expiryPropertyDate = new Date(currentDate.setFullYear(currentDate.getFullYear() + 1));
        if (!validateForm()) {
            return;
        }
        const formattedImages = JSON.stringify(images).replace(/^\[|\]$/g, "");
        setIsLoading(true)
        event.preventDefault();
        const mydata = {
            "verification_token": "123456",
            "table": "property_offers",
            "PropertyName": offerTitle,
            "NumberOfRooms": noOfRooms,
            "Neighborhood": neighbour,
            "Location": location,
            "District": district,
            "Price": price,
            "ContactNumber": phoneNumber,
            "DeveloperName": developerName,
            "PropertyType": propertyType,
            "PropertyStatus": propertyStatus,
            "Area": area,
            "Status": "active",
            "Description": offerDetail,
            "IsArchived": 0,
            "CreatedByID": userInfo?.id,
            // "OfferId": data ? data?.id : "",
            "Pictures": formattedImages,
            "ExpiryDate": expiryPropertyDate,
            "Is_Featured": isFeatured ? 1 : 0,

        }
        try {
            const result = await postData('/insert', mydata)
            console.log(result, "result in the submit form")
            if (result?.message === "success") {
                toastService.showSuccess("Submit Successfully")
                setIsLoading(false)
                setOfferTitle("")
                setNoOfRooms("")
                setLocation("")
                setDistrict("")
                setPrice("")
                setDeveloperName("")
                setPropertyType("")
                setPropertyStatus("")
                setPaymentMethod("")
                setArea("")
                setOfferDetail("")
                setNeighbour("")
                setPhoneNumber("")
                setImages([])
            } else {
                toastService.showError("Something went wrong")
                setIsLoading(false)

            }

        } catch (error) {
            console.log(error, "error is submit form")
            setIsLoading(false)

        }
    };


    const submitRequest = async () => {
        const currentDate = new Date();
        const expiryPropertyDate = new Date(currentDate.setFullYear(currentDate.getFullYear() + 1));
        // if (!validateForm()) {
        //     return;
        // }
        setIsLoading(true)
        const data = {
            "verification_token": "123456",
            "table": "request_offer",
            "title": offerTitle,
            "NumberOfRooms": noOfRooms,
            "Location": location,
            "District": district,
            "Price": price,
            "DeveloperName": developerName,
            "PropertyType": propertyType,
            "PropertyStatus": propertyStatus,
            "Area": area,
            // "ContactNumber": phone,
            // "Neighborhood": neighborhood,
            "Description": offerDetail,
            "IsArchived": 0,
            "createdBy": userInfo?.id,
            "payment_method": paymentMehod,
            "ExpiryDate": expiryPropertyDate,
        }
        try {
            const result = await postData('/insert', data)
            setIsLoading(false)
            console.log(result, "AD>A>>#>$>$>#>$>#>$$")
            if (result?.message === "success") {
                setOfferTitle("")
                setNoOfRooms("")
                setLocation("")
                setDistrict("")
                setPrice("")
                setDeveloperName("")
                setPropertyType("")
                setPropertyStatus("")
                setPaymentMethod("")
                setArea("")
                setOfferDetail("")
                setStartDate('')
                toastService.showSuccess("Request has been sent successfully")
            } else {
                setIsLoading(false)

            }

        } catch (error) {
            console.log(error, "error is submit form")
            setIsLoading(false)

        }
    }




    const handleSelect = (selectedOption) => {
        setPropertyType(selectedOption?.value)
    };

    const handleselectPropertyStatus = (selectedOption) => {
        setPropertyStatus(selectedOption?.value)
    };

    const handleSelectPaymentMethod = (selected) => {
        setPaymentMethod(selected?.value)
    }


    return (

        <>
            <Loader isLoading={isLoading} />
            <Navbar />
            <div className="containers">
                <div className="CrateOffer-container">
                    <h2> {offerType === "Offer" ? "Create Offer" : "Create Request"} </h2>
                    <div className="signin-form">
                        <div className="signin-form1">
                            <h2>Property Detail</h2>
                            <form onSubmit={handleSubmitOffer}>
                                <div className="input-field">
                                    <div className="input-wrapper">
                                        <label className='input-title'>Title</label>
                                        {/* <i className="fas fa-envelope"></i> */}
                                        <input
                                            type="text"
                                            id="offerTitle"
                                            placeholder="Enter Title"
                                            value={offerTitle}
                                            onChange={(e) => setOfferTitle(e.target.value)}
                                            required
                                        />
                                    </div>
                                </div>

                                <div className="input-field">
                                    <div className="input-wrapper">
                                        <label className='input-title'>Number of rooms</label>
                                        <input
                                            type="text"
                                            id="noOfRooms"
                                            placeholder="Enter Number Of Rooms"
                                            value={noOfRooms}
                                            onChange={(e) => setNoOfRooms(e.target.value)}
                                            required
                                        />
                                    </div>
                                </div>
                                {offerType === "Offer" ?
                                    <div className="input-field">
                                        <div className="input-wrapper">
                                            <label className='input-title'>Location</label>
                                            <input
                                                type="text"
                                                id="location"
                                                placeholder="Enter Location"
                                                value={location}
                                                onChange={(e) => setLocation(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    :
                                    null
                                }
                                <div className="input-field">
                                    <div className="input-wrapper">
                                        <label className='input-title'>District</label>
                                        <input
                                            type="text"
                                            id="district"
                                            placeholder="Enter District"
                                            value={district}
                                            onChange={(e) => setDistrict(e.target.value)}
                                            required
                                        />
                                    </div>
                                </div>
                                <div className="input-field">
                                    <div className="input-wrapper">
                                        <label className='input-title'>Price</label>
                                        <input
                                            type="text"
                                            id="price"
                                            placeholder="Enter Price"
                                            value={price}
                                            onChange={(e) => setPrice(e.target.value)}
                                            required
                                        />
                                    </div>
                                </div>
                                {offerType === "Offer" ?
                                    <div className="input-field">
                                        <div className="input-wrapper">
                                            <label className='input-title'>Phone Number</label>
                                            <input
                                                type="text"
                                                id="phoneNumber"
                                                placeholder="Enter Phone Number"
                                                value={phoneNumber}
                                                onChange={(e) => setPhoneNumber(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    :
                                    null}

                                <div className="input-field">
                                    <div className="input-wrapper">
                                        <label className='input-title'>Property Status</label>
                                        <Dropdown
                                            options={PROPERTY_STATUS}
                                            onSelect={handleselectPropertyStatus}
                                            placeholder="Select Property Status"
                                        />
                                    </div>
                                </div>

                                {offerType === "Offer" ?
                                    <div className="input-field">
                                        <div className="input-wrapper">
                                            <label className='input-title'>Neighbourhood</label>
                                            <input
                                                type="text"
                                                id="neighbour"
                                                placeholder="Enter Neighbourhood"
                                                value={neighbour}
                                                onChange={(e) => setNeighbour(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    :
                                    null}

                                {offerType === "Offer" ?

                                    <div className="input-field">
                                        <div className="input-wrapper">
                                            <label className='input-title'>Developer Name</label>
                                            <input
                                                type="text"
                                                id="developerName"
                                                placeholder="Enter Developer Name"
                                                value={developerName}
                                                onChange={(e) => setDeveloperName(e.target.value)}
                                                required
                                            />
                                        </div>
                                    </div>
                                    :
                                    null
                                }


                                {offerType === "Offer" ?
                                    null
                                    :

                                    <div className="input-field">
                                        <div className="input-wrapper">
                                            <label className='input-title'>Select Payment Method</label>
                                            <Dropdown
                                                options={PAYMENT_METHOD}
                                                onSelect={handleSelectPaymentMethod}
                                                placeholder="Select Payment Method"
                                            />
                                        </div>
                                    </div>
                                }
                                {/* {offerType === "Offer" ?
                                    <div className="input-field">
                                        <label className='input-title'>Select Expiry Date</label>
                                        <ReactDatePicker
                                            selected={startDate}
                                            onChange={(date) => setStartDate(date)}
                                            dateFormat="dd/MM/yyyy"
                                            showMonthDropdown
                                            showYearDropdown
                                            dropdownMode="select"
                                            className='Date-picker-style'
                                        />
                                    </div>
                                    :
                                    null
                                } */}


                                <div className="input-field">
                                    <div className="input-wrapper">
                                        <label className='input-title'>Property Type</label>
                                        <Dropdown
                                            options={PROPERTY_TYPE}
                                            onSelect={handleSelect}
                                            placeholder="Select Property Type"
                                        />
                                    </div>
                                </div>

                                <div className="input-field">
                                    <div className="input-wrapper">
                                        <label className='input-title'>Area</label>
                                        <input
                                            type="text"
                                            id="area"
                                            placeholder="Enter Area (Optional)"
                                            value={area}
                                            onChange={(e) => setArea(e.target.value)}
                                            required
                                        />
                                    </div>
                                </div>
                                {offerType === "Offer" ?
                                    <div className="input-field">
                                        <div className="input-wrapper">
                                            <label className="input-title">Upload Images</label>
                                            <input type="file" onChange={handleImageUpload} multiple />
                                        </div>
                                    </div>
                                    :
                                    null}



                                <div className="input-field">
                                    <div className="input-wrapper">
                                        <label className="input-title">Is Featured?</label>
                                        <div className="button-group">
                                            <button
                                                type="button"
                                                className={`feature-button ${isFeatured === true ? 'selected' : ''}`}
                                                onClick={() => setIsFeatured(true)}
                                            >
                                                Yes
                                            </button>
                                            <button
                                                type="button"
                                                className={`feature-button ${isFeatured === false ? 'selected' : ''}`}
                                                onClick={() => setIsFeatured(false)}
                                            >
                                                No
                                            </button>
                                        </div>
                                    </div>
                                </div>


                                <div className="uploaded-images-container">
                                    {images.map((url, index) => (
                                        <div className="image-wrapper" key={index}>
                                            <img src={url} alt={`Uploaded ${index + 1}`} className="uploaded-image" />
                                            <button
                                                className="remove-image-btn"
                                                onClick={() => handleRemoveImage(index)}
                                            >
                                                &times;
                                            </button>
                                        </div>
                                    ))}
                                </div>

                                <div className="input-field">
                                    <div className="input-wrapper">
                                        <label className='input-title'>Offer Detail</label>
                                        <textarea
                                            type="text"
                                            id="offerDetail"
                                            placeholder="Enter Offer Detail"
                                            value={offerDetail}
                                            onChange={(e) => setOfferDetail(e.target.value)}
                                            required
                                            className="textarea"

                                        />
                                    </div>
                                </div>
                                {offerType === "Offer" ? (
                                    <button type="button" onClick={handleSubmitOffer}>Submit Offer</button>
                                ) : (
                                    <button type="button" onClick={submitRequest}>Submit Request</button>
                                )}

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </>

    );
}


export default CreateOffer